import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import '../../../styles/Footer.scss'; // You might want to create this file for styling

const Footer = () => {
  return (
    <Box className='footer-container'>
      <Card sx={{ marginBottom: '-14px' }}>
        <CardContent>
          <Typography variant='body2' className='footer-text'>
            Atithiseva Copyright © 2024 | All Rights Reserved
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Footer;
